// import React from "react";
// import { MdSearch, MdNotifications } from "react-icons/md";
// import { useNavigate } from "react-router-dom";
// import "./CoinsHeader.css";

// function CoinsHeader({ onAddCoin }) {
//   const navigate = useNavigate();

//   return (
//     <div className="sales-header">
//       {/* Top Row */}
//       <div className="sales-header-top">
//         <div className="search-box">
//           <MdSearch />
//           <input type="text" placeholder="Search for anything" />
//         </div>

//         <div className="notification-box">
//           <MdNotifications />
//           {/* <span className="notification-dot"></span> */}
//         </div>
//       </div>

//       {/* Bottom Row */}
//       <div className="sales-header-bottom">
//         <div>
//           <h1>Coins</h1>
//           <p>Manage coin packages</p>
//         </div>

//         <div className="header-actions">
//           <button className="btn-outline" onClick={() => navigate(-1)}>
//             Back
//           </button>
//           <button className="btn-primary" onClick={onAddCoin}>
//             Add Coins
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default CoinsHeader;



import React, { useState } from "react";
import { MdSearch, MdNotifications } from "react-icons/md";
import "./CoinsHeader.css";

const SalesHeader = ({
  onAddCoin,
  searchTerm,
  onSearchChange,
  hasNewNotification,
  clearNotification,
}) => {
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);

  return (
    <div className="sales-header">

      {/* LEFT HEX PATTERN */}
      <svg className="hex-left" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern
            id="hexPatternLeft"
            width="20"
            height="17.5"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M10 0 L20 5 L20 12.5 L10 17.5 L0 12.5 L0 5 Z"
              fill="none"
              stroke="rgba(180,190,190,0.7)"
              strokeWidth="0.6"
            />
            <circle cx="10" cy="8.75" r="1.2" fill="rgba(180,190,190,0.7)" />
          </pattern>

          <linearGradient id="fadeGradientLeft" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="white" stopOpacity="1" />
            <stop offset="100%" stopColor="white" stopOpacity="0" />
          </linearGradient>

          <mask id="maskFadeLeft">
            <rect width="100%" height="100%" fill="url(#fadeGradientLeft)" />
          </mask>
        </defs>

        <rect
          width="100%"
          height="100%"
          fill="url(#hexPatternLeft)"
          mask="url(#maskFadeLeft)"
        />
      </svg>

      {/* RIGHT HEX PATTERN */}
      <svg className="hex-right" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="fadeGradientRight" x1="1" y1="0" x2="0" y2="0">
            <stop offset="0%" stopColor="white" stopOpacity="1" />
            <stop offset="100%" stopColor="white" stopOpacity="0" />
          </linearGradient>

          <mask id="maskFadeRight">
            <rect width="100%" height="100%" fill="url(#fadeGradientRight)" />
          </mask>
        </defs>

        <rect
          width="100%"
          height="100%"
          fill="url(#hexPatternLeft)"
          mask="url(#maskFadeRight)"
        />
      </svg>

      {/* CONTENT */}
      <div className="header-content">

        {/* TOP ROW */}
        <div className="header-top">

          <div className="search-desktop">
            <MdSearch />
            <input
              type="text"
              placeholder="Search coins..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>

          <button
            className="search-mobile-btn"
            onClick={() => setShowMobileSearch(!showMobileSearch)}
          >
            <MdSearch />
          </button>

          <button
            className="notification-btn"
            onClick={() => {
              setShowNotifications(!showNotifications);
              clearNotification();
            }}
          >
            <MdNotifications />
            {hasNewNotification && <span className="notification-dot" />}
          </button>
        </div>

        {showMobileSearch && (
          <div className="search-mobile">
            <MdSearch />
            <input
              type="text"
              placeholder="Search coins..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              autoFocus
            />
          </div>
        )}

        {/* BOTTOM ROW */}
        <div className="header-bottom">
          <div>
            <h1>Coins</h1>
            <h3>Create coins for user</h3>
          </div>

          <button className="add-btn" onClick={onAddCoin}>
            Add Coins
          </button>
        </div>
      </div>
    </div>
  );
};

export default SalesHeader;

